import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/app/global-error.tsx");
